module.exports = __webpack_public_path__ + "static/OpenSans-Regular-e93b4434d2ae435193c7a11a19efbfcb.woff2";